export const isAssessmentMediaPath = (value: string): boolean => {
  const trimmed = value.trim()
  if (!trimmed) return false

  return !/^(?:[a-z][a-z\d+\-.]*:|\/\/)/i.test(trimmed)
}
